import { Col, Form, Modal, Row } from 'antd';
import Styled from 'styled-components';
import { Button } from '../../../components/buttons/buttons';

const TableHeader = Styled.div`
  display: flex;
  gap: 20px;
  flex-wrap: wrap;
  flex-direction: row;
`;

const SearchForm = Styled(Form)`
  flex: 1;
  align-items: flex-end;
  gap: 15px;
  margin-bottom: 20px;
  display: flex;
  flex-wrap: wrap;
  min-width: 80%;
`;

const SearchFormText = Styled.p`
  flex: 1;
  min-width: 150px;
  color: #686868;
  text-align: left;
  font-size: 1.3em;
  font-weight: 800;
  padding: 0px;
  margin: 0px;
  .small {
    font-weight: 400;
    font-size: 0.9em;
  }
`;

const SearchFormInputContainer = Styled.div`
  flex: 1 1 200px;
  min-width: 80%;
  padding-bottom: 8px;
  .ant-form-item {
    margin: 0px;
    border-bottom: solid 1px #cdcdcd;
  }
  .ant-btn-danger {
    background: none;
    color: red;
  }
  & input {
    border-top: 0px;
    border-right: 0px;
    border-left: 0px;
  }
`;

const SearchFormAction = Styled.div`
  flex: 1;
  padding-bottom: 8px;
  display: flex;
  justify-content: right;
  align-items: flex-end;
`;

const ContentActions = Styled.ul`
`;

const ActionItem = Styled.div`
  display: flex;
  gap: 20px;
  justify-content: left;
  :hover {
    /* font-weight: 570; */
    background-color:#E4E7EA;
  }
  .anticon {
    margin-top: 4px;
  }
  .buttonAction{
    display: flex;
    border: none;
    width: 100%;
    background: transparent;
    justify-content: left;
  }
`;

const TableContainer = Styled.div`
  .ant-table{
    font-size: 13px;
  }
  .history-actions {
    .item-actions-button {
      background: #D9D9D9 !important;:
    }
    .confirmation-item {
      background: #00af50 !important;
      .icons {
        background: #00af50 !important;
        color: white !important;
      }
    }
  }
`;

const ButtonActionHistory = Styled(Button)`
  box-shadow: none;
  padding: 0px 0px;
  height: 25px !important;
  width: 25px !important;
  min-width: 25px !important;
  .icons {
    width: 17px;
  }
`;

const ContentButtonSettings = Styled(Row)`
  max-width: 36px;
  justify-content: center;
  text-align: center;
  cursor: pointer;
  div {
    width: 100%;
    border-color: red !important;
    border-color: #e8e8e8;
    background: #e8e8e8;
    justify-content: center;
    vertical-align: center;
    svg {
      width: 32px;
      margin-top: 10px;
      color: #AAAAAA;
    }
  }
`;

const ButtonSettingColums = Styled(Button)`
  width: 100%;
  height: 33px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  border-color: #e8e8e8;
  background: #e8e8e8;
  color: #aaaaaa;
  box-shadow: none;

  .list {
    font-size: 30px;
    margin: auto;
  }
`;

const ModalCancel = Styled(Modal)`
`;

const AlertDecoratorContainer = Styled.span`
  background: ${(data) => data.background};
  height: 10px;
  width: 10px;
  border-radius: 50%;
  padding: 0 !important;
  display: flex !important;
  align-items: center;
  justify-content: center;
  animation: sonar 2s infinite;
  margin: auto;

  .icon {
    color: white !important;
    width: 16px !important;
    height: 16px !important;
  }

  @keyframes sonar {
    0% {
      box-shadow: 0 0 0 0 ${(data) => data.background}AA;
    }
    100% {
      box-shadow: 0 0 0 10px ${(data) => data.background}00;
    }
  }
`;

const ContainerAlert = Styled(Col)`
  margin: auto !important;
  margin-top: 10px;
`;

export {
  SearchForm,
  SearchFormText,
  SearchFormAction,
  SearchFormInputContainer,
  TableHeader,
  ActionItem,
  ContentActions,
  TableContainer,
  ButtonActionHistory,
  ModalCancel,
  ButtonSettingColums,
  ContentButtonSettings,
  AlertDecoratorContainer,
  ContainerAlert,
};